<template>
  <div class="">
    <div class="content">
      <div v-if="restaurant" class="single">
        <Restaurant></Restaurant>
      </div>
      <div v-else>
        <div class="meta">
          <div class="filter">
            <v-text-field
              v-model="search"
              append-icon="search"
              :label="$t('admin.views.restaurants.filter')"
              single-line
              hide-details
            ></v-text-field>
          </div>
          <div class="buttons">
            <v-btn v-if="!restaurant" outline @click="add" color="success"
              >{{ $t('admin.views.restaurants.create') }}</v-btn
            >
          </div>
        </div>
        <v-data-table
          :custom-filter="filter"
          :headers="headers"
          :items="restaurants"
          class=""
          :no-results-text="message_not_found"
          :rows-per-page-items="rows_per_page"
          :pagination.sync="pagination"
          :search="search"
          :must-sort="true"
          :rows-per-page-text="message_rows_per_page"
        >
          <template v-slot:items="props">
            <td>{{ props.item.site }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.region_name }}</td>
            <td>{{ props.item.city }}</td>
            <td v-if="market === 'ES'" :key="props.item.mop_service">
              {{
                props.item.mop_service &&
                (props.item.mop_service == "true" ||
                  props.item.mop_service == 1)
                  ? "Activo"
                  : "Inactivo"
              }}
            </td>
            <td v-if="market === 'ES'">{{ props.item.mop_status }}</td>
            <td>{{ props.item.active == 1 ? "Activo" : "Inactivo" }}</td>
            <td>
              <v-icon light @click="edit(props.item)">edit</v-icon>
              <v-icon light @click="remove(props.item)">delete</v-icon>
            </td>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Restaurant from "@/components/domain/admin/Restaurant";

export default {
  name: "Restaurants",
  props: { page: String },
  components: { Restaurant },
  data() {
    return {
      search: "",
      id: -1,
      message_not_found: i18n.t('admin.views.restaurants.message_not_found'),
      message_rows_per_page: i18n.t('admin.views.restaurants.message_rows_per_page'),
      rows_per_page: [10, 50, 100, { text: "Todos", value: -1 }],
      pagination: {
        rowsPerPage: 50
      },
      add_restaurant: {
        id: -1,
        name: "",
        active: "1",
        mop_service: false,
        site: "",
        email: "",
        address: "",
        cp: "",
        city: "",
        etof: false,
        mcauto: false,
        type: -1,
        region: -1,
        delivery: false
      }
    };
  },
  computed: {
    restaurants() {
      var restaurants = ObjectToArray(
        this.$store.getters["locations/getLocations"]
      );
      for (var i in restaurants) {
        restaurants[i].region_name = this.regions[restaurants[i].region].name;
      }

      return restaurants;
    },
    regions() {
      return this.$store.getters["locations/getRegions"];
    },
    restaurant() {
      return this.$store.getters["locations/getRestaurantSelected"];
    },
    market() {
      return this.$store.getters["getMarket"];
    },
    headers() {
      return [
        { text: i18n.t('general.headers.site'), value: "site", width: "75px", align: "left" },
        { text: i18n.t('general.name'), value: "name", align: "left" },
        { text: i18n.t('general.region'), value: "region_name", align: "left" },
        { text: i18n.t('general.headers.city'), value: "city", align: "left" },
        ...(this.market === 'ES' ? [{ text: i18n.t('general.headers.mop'), value: "mop_service", align: "left" }] : []),
        ...(this.market === 'ES' ? [{ text: i18n.t('general.headers.mop_status'), value: "mop_status", align: "left" }] : []),
        { text: i18n.t('general.active'), value: "active", align: "left" },
        { text: "", value: "actions", width: "120px", align: "right" }
      ];
    }
  },
  methods: {
    edit(restaurant) {
      console.log(restaurant);
      this.$store.commit("locations/setSelectedRestaurant", restaurant);
    },
    remove(restaurant) {
      var self = this;
      this.$popup.confirm(
        i18n.t('admin.views.restaurants.popup.delete'),
        i18n.t('admin.views.restaurants.popup.delete_message', { name: restaurant.site + " - " + restaurant.name }),
        i18n.t('general.accept'),
        i18n.t('general.cancel'),
        function() {
          self.$store.dispatch("locations/removeRestaurant", restaurant.id);
        }
      );
    },
    add() {
      this.$store.commit(
        "locations/setSelectedRestaurant",
        this.add_restaurant
      );
    },
    filter(items, search, filter) {
      var aItems = [];
      items.forEach(item => {
        if (
          filter(
            item.name
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase(),
            search
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
          ) ||
          filter(item.site, search) ||
          filter(item.region_name, search) ||
          filter(item.city, search)
        ) {
          aItems.push(item);
        }
      });
      return aItems;
    }
  },
  watch: {
    // call again the method if the route changes
    // '$route': 'loadDataPage'
  },
  created() {
    this.$store.commit("setTitle", i18n.t('admin.views.restaurants.name'));
    this.$store.commit("setMenuVisible", false);

    switch (this.page) {
      case "edit":
        this.$store.commit(
          "locations/setSelectedRestaurantByID",
          this.$route.params.id
        );
        break;
      case "add":
        this.$store.commit(
          "locations/setSelectedRestaurant",
          this.add_restaurant
        );
        break;
      default:
        break;
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.sidebar-cnt {
  width: 300px;
  display: inline-block;
  float: left;
}
.content {
  width: 100%;
  display: inline-block;
  float: left;
  padding: 20px 40px 50px;
  position: relative;

  td {
    .v-icon {
      margin-left: 5px;
    }
  }

  .meta {
    margin-bottom: 25px;
    overflow: hidden;

    .filter {
      float: left;
      width: 400px;
    }
    .buttons {
      float: right;
    }
  }

  .header {
    width: 100%;
    text-align: left;
    margin-bottom: 15px;
    overflow: hidden;

    .meta {
      float: left;
      width: 70%;

      .breadcrumbs {
        color: #aaa;
        display: block;
        width: 100%;

        .cat1 {
          display: inline-block;
          font-weight: bold;
          font-family: Speedee-Bold;
        }
        .cat2 {
          display: inline-block;

          &:before {
            content: "|";
            margin: 0 5px;
          }
        }
      }
      .title {
        background: var(--main_color);
        color: var(--dark_color);
        width: auto;
        display: inline-block;
        text-align: left;
        float: left;
        font-size: 25pt;
        font-family: Speedee-Bold;
        padding: 0 5px;
        margin: 0;
        margin-top: 5px;
        line-height: 25pt;
        padding-bottom: 5px;
      }
    }

    .filter {
      float: left;
      width: 30%;
      text-align: right;
      padding: 0 10px;

      .search {
        display: block;
        overflow: hidden;
        margin-top: 5px;
        -webkit-transition: all 1s;
        transition: all 1s;

        .input {
          border: none;
          border-bottom: 2px solid #ccc;
          padding: 5px;
          outline: none;
          background: url("/img/magnify.svg") no-repeat right 5px center;
          background-size: 20px;
          width: 100%;
          float: left;
        }
        .icon {
          display: none;
          cursor: pointer;
          width: 30px;
          height: 30px;
          background: url("/img/go.svg") no-repeat center var(--main_color);
          background-size: 20px;
          border-radius: 3px;
        }
        &.active {
          .input {
            width: calc(100% - 40px);
            background: transparent;
          }
          .icon {
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>
